
import Vue from 'vue'
import Vuex from 'vuex'
import {secondsToFullTimestamp, toNumber} from '@/Helper.js' 
import { kardexCollection, customAuth, productsCollection, coleccion_entradas, coleccion_salidas, db, _firestore} from '@/FirebaseConfig';
Vue.use(Vuex)
export default {
  namespaced:true,
  state:{
    record: [],
    esta_la_funcion_activa: false,
    batchList: {},
    existenceToUpdate : [],
    key: '',
    creado_por: '',
    coleccion_seleccionada: '',
    tipo_de_operacion: '',
    arreglo_ultima_operacion_en_total: [],
    motivo_sin_variacion_en_almacen_total : ['04', '13'],
    mensaje_de_error: '',
    costo_del_elemento_actual: 0,
    documento: [],
    items: [],
    lista_de_operaciones_a_grabar_en_almacen: {},
    lista_de_operaciones_a_grabar_en_almacen_total: {}

  },
  mutations: {
    validar_proceso: (state)=>{
      let hay_errores = []
      const {documento} = state
      const {items} = documento
      items.map( ({costo, cantidad, descripcion, cantidad_que_queda_en_almacen}) => {
        
        if(cantidad<=0) hay_errores.push(`La cantidad de ${descripcion} no puede ser menor o igual que 0`)
        
        if(state.tipo_de_operacion === 'entrada'){
          if(costo<0) hay_errores.push(`El costo de ${descripcion} no puede ser menor a 0`)
        } else if (state.tipo_de_operacion === 'salida'){
          let cantidad_que_queda = ( cantidad_que_queda_en_almacen.length > 0 )
            ? cantidad_que_queda_en_almacen.map(item=> item.entradas_subtotal).reduce((a, b) =>  a + b, 0 ) 
            : 0
          if(!cantidad_que_queda) hay_errores.push(`No he podido obtener la cantidad`)
          if(cantidad > cantidad_que_queda) hay_errores.push(`No existen existencias suficientes para (${cantidad}) ${descripcion}. quedan solo ${cantidad_que_queda} `)
        }
      })
      
      if( hay_errores.length > 0 ) hay_errores.map( (item, i) => state.mensaje_de_error += `${i+1}. ${item} `)  
      
    },
    llenar_operacion_de_kardex: (state, es_almacen_total) => {
      try{
        state.documento.items = state.documento.items.map( item => {    
          const {arreglo_ultima_operacion_en_total, tipo_de_operacion, documento} = state
          const es_entrada = tipo_de_operacion === 'entrada'
          let {costo, cantidad, ultima_operacion, key} = item
          let {existencias_total, existencias_cantidad} = ultima_operacion
          const {documento_de_operacion, numero_de_operacion, nombre_motivo_de_traslado, warehouse} = documento
          costo = es_almacen_total ? 0 : Number(costo)
          cantidad = Number(cantidad)
          existencias_total = Number(existencias_total)
          existencias_cantidad = Number(existencias_cantidad)
            
          const nuevo_total = (es_entrada) 
          ? es_almacen_total ? 0 : ( ultima_operacion.length == 0 ) ? toNumber(costo*cantidad) : toNumber( existencias_total + costo * cantidad)
          : es_almacen_total ? 0 : toNumber( existencias_total - cantidad * costo)
          
          if(es_almacen_total) arreglo_ultima_operacion_en_total[key] = (es_entrada)
            ? arreglo_ultima_operacion_en_total[key] + cantidad
            : arreglo_ultima_operacion_en_total[key] - cantidad

          let nueva_cantidad = (es_entrada) 
            ? (es_almacen_total)
              ? arreglo_ultima_operacion_en_total[key] 
              : (ultima_operacion.length == 0) ? cantidad :  existencias_cantidad + cantidad
            : (es_almacen_total)
              ? arreglo_ultima_operacion_en_total[key] 
              : existencias_cantidad  - cantidad
              
              
          let numero_de_kardex = ( ultima_operacion.length == 0 || !ultima_operacion.numero_de_kardex ) ? 1 : ultima_operacion.numero_de_kardex++
              
          let lista_de_operaciones_a_grabar = es_almacen_total ? state.lista_de_operaciones_a_grabar_en_almacen : state.lista_de_operaciones_a_grabar_en_almacen_total
              
          lista_de_operaciones_a_grabar[key] = ( !lista_de_operaciones_a_grabar[key] ) 
            ? { existencias_cantidad: nueva_cantidad, existencias_total: nuevo_total, numero_de_kardex } 
            : {
                existencias_cantidad: es_entrada 
                  ? lista_de_operaciones_a_grabar[key].existencias_cantidad + cantidad 
                  : lista_de_operaciones_a_grabar[key].existencias_cantidad - cantidad,
                
                existencias_total: es_entrada 
                  ? es_almacen_total ? 0 : lista_de_operaciones_a_grabar[key].existencias_total + costo * cantidad 
                  : es_almacen_total ? 0 : lista_de_operaciones_a_grabar[key].existencias_total - costo * cantidad,

                numero_de_kardex: lista_de_operaciones_a_grabar[key].numero_de_kardex++
              } 
                
          lista_de_operaciones_a_grabar[key].existencias_costo = (es_entrada) 
            ? es_almacen_total ? 0 : toNumber(lista_de_operaciones_a_grabar[key].existencias_total/lista_de_operaciones_a_grabar[key].existencias_cantidad)
            : es_almacen_total ? 0 : ( lista_de_operaciones_a_grabar[key].existencias_total===0 || lista_de_operaciones_a_grabar[key].existencias_cantidad===0 ) ? 0 : toNumber(lista_de_operaciones_a_grabar[key].existencias_total/lista_de_operaciones_a_grabar[key].existencias_cantidad)
            
          const movimiento_de_kardex = {
            numero_de_kardex          : lista_de_operaciones_a_grabar[key].numero_de_kardex,
            existencias_costo         : lista_de_operaciones_a_grabar[key].existencias_costo,
            existencias_cantidad      : lista_de_operaciones_a_grabar[key].existencias_cantidad,
            existencias_total         : lista_de_operaciones_a_grabar[key].existencias_total,
            entradas_costo            : es_almacen_total ? 0        : (es_entrada) ? costo : 0, 
            entradas_cantidad         : (es_entrada)     ? cantidad : 0,
            entradas_subtotal         : es_almacen_total ? 0        : (es_entrada) ? cantidad : 0,
            entradas_total            : es_almacen_total ? 0        : (es_entrada) ? costo * cantidad : 0,
            salidas_costo             : es_almacen_total ? 0        : (es_entrada) ? 0 : costo,
            salidas_cantidad          : (es_entrada)     ? 0        : cantidad,
            salidas_total             : es_almacen_total ? 0        : (es_entrada) ? 0 : costo * cantidad,
            creado_el                 : new Date(), 
            documento_de_operacion    : documento_de_operacion, 
            numero_de_operacion       : numero_de_operacion, 
            nombre_motivo_de_traslado : nombre_motivo_de_traslado,
            almacen                   : warehouse.map( ( {name, slug} ) => ( { name, slug } ) ),
            creado_por                : customAuth.currentUser.displayName,
            llave                     : state.key,
          }   
          return ({...item, movimiento_de_kardex})
        })
      } catch (error){
        console.log(error)
      }
    },
    obtener_costo_del_kardex: (state) => {
      try{
        const {documento, tipo_de_operacion} = state
        const {items} = documento
        const es_entrada = tipo_de_operacion === 'entrada'
    
        state.documento.items = items.map(item=>{
          if (es_entrada){
            return {...item, costo : item.costo || item.valor_unitario || 0 }
          } else {
            const { cantidad, cantidad_que_queda_en_almacen, batchWarehouse, selectedWarehouse, key } = item
            let cantidad_total_a_remover = cantidad
            let costo_acumulado = 0
            let index = 0
            do{
              let fila = cantidad_que_queda_en_almacen[index]
              let cantidad_que_queda = fila.entradas_subtotal
              costo_acumulado += (cantidad_total_a_remover >= cantidad_que_queda) ? fila.entradas_costo * cantidad_que_queda : fila.entradas_costo * cantidad_total_a_remover
              state.batchList[batchWarehouse].update( kardexCollection.doc(selectedWarehouse.slug).collection(key).doc(fila.key), {entradas_subtotal: _firestore.FieldValue.increment((cantidad_total_a_remover >= cantidad_que_queda) ? cantidad_que_queda*-1 : cantidad_total_a_remover*-1)})
              cantidad_total_a_remover = (cantidad_total_a_remover >= cantidad_que_queda) ? cantidad_total_a_remover - cantidad_que_queda : 0
              index++
            } while (cantidad_total_a_remover > 0)
            return {...item, costo : toNumber(costo_acumulado/cantidad) }
          }
        })
      } catch (error){
        console.log(error)
      }

    },
    limpiar_funcion: (state)=>{
      state.batchList= {},
      state.existenceToUpdate = [],
      state.key= '',
      state.creado_por= '',
      state.coleccion_seleccionada= '',
      state.tipo_de_operacion= '',
      state.arreglo_ultima_operacion_en_total= [],
      state.motivo_sin_variacion_en_almacen_total = ['04', '13'],
      state.mensaje_de_error= '',
      state.costo_del_elemento_actual= 0,
      state.documento = [],
      state.items = [],
      state.lista_de_operaciones_a_grabar_en_almacen= {},
      state.lista_de_operaciones_a_grabar_en_almacen_total= {}
      state.esta_la_funcion_activa = false
    }
  },
  actions: {
    getAll: ( {state, dispatch }, {warehouse, item })=>{
      state.record = []
      if( !warehouse ) return dispatch('imprimir', 'Debe seleccionar un almacén') 
      if( !item ) return dispatch('imprimir', 'Debe seleccionar un producto') 

      kardexCollection.doc(warehouse).collection(item).orderBy( 'creado_el', 'desc' ).get()
        .then(collection=> collection.docs.map( item => {
          state.record.push( item.data() )
          state.loading = false
        } ) )
        .catch( error => console.log( error ) )
    },

    lookingForDates:({dispatch, state, commit}, {warehouse, item})=>{
      if(!warehouse) return dispatch('imprimir', 'Debe seleccionar un almacén') 
      if(!item) return dispatch('imprimir', 'Debe seleccionar un producto') 

      state.record = []
      kardexCollection.collection(warehouse).doc(item)
      .get().then( doc =>{ 
        let arr =  Object.keys(doc.data())
        .map(item => doc.data()[item])
        .filter(item=>new Date(item.createdAt.toDate() ) >= new Date(state.searchingDate[0] ))
        .filter(item=>new Date(item.createdAt.toDate() ) < new Date(state.searchingDate[1] ))
        .get()
        .then(collection=> collection.docs.map(item => {
          state.record.push( item.data() )
          state.loading = false
        }))
        .catch( error => console.log(error) )
      }) 
    },

    proceso_masivo: async ({ commit, dispatch }, {elementos_seleccionados, tipo_de_operacion}) => {
      for await (const elemento of elementos_seleccionados){
        await dispatch('comprobar_proceso_disponible', {key: elemento.id, tipo_de_operacion})
        commit('Helpers/launchSnackbar', `Se ha procesado el documento ${elemento.numero_de_operacion}`, { root: true }) 
      }
      commit('Helpers/launchSnackbar', 'Se ha procesado la lista con éxito', { root: true }) 
    },

    comprobar_proceso_disponible: async ({ state, dispatch, commit}, data) => {
      if (state.esta_la_funcion_activa) return dispatch('imprimir', 'La operación de almacenamiento está ocupada, espere un momento')
      state.esta_la_funcion_activa = true
      state.existenceToUpdate = []
      await dispatch( 'procesar', data )
      commit( 'limpiar_funcion' )
    },

    procesar: async ({state, dispatch, commit}, {key, tipo_de_operacion, es_reversion}) => { 

      state.key = key
      state.tipo_de_operacion = tipo_de_operacion
      state.es_reversion = es_reversion || false
      state.coleccion_seleccionada = state.tipo_de_operacion == 'entrada' 
        ? !es_reversion ? coleccion_entradas : coleccion_salidas
        : !es_reversion ? coleccion_salidas : coleccion_entradas
      state.estado_inicial = !es_reversion ? 'esperando' : 'procesado'
      state.estado_final = es_reversion ? 'esperando' : 'procesado'
        
      let almacenes_procesados = ''
      /**EVITAR DOBLE OPERACIÓN */
      await dispatch('obtener_documento')
      let { documento, mensaje_de_error, estado_inicial, estado_final } = state
      try{
          
        let { estado_del_documento, numero_de_operacion, documento_de_operacion,total_gravada, serie_comprobante, numero_comprobante, tipo_de_comprobante, proveedor_denominacion, condiciones_de_pago } = documento
        if ( estado_del_documento == 'procesado' && !es_reversion ) return commit( 'Helpers/launchSnackbar', `Ya está procesado el documento ${ numero_de_operacion }`, { root: true }) 
        if ( estado_del_documento == 'procesando' && !es_reversion ) return commit( 'Helpers/launchSnackbar', `El documento ${ numero_de_operacion } está siendo procesado por otro usuario`, { root: true }) 
        /**INICIAR OPERACIÓN */
        dispatch('retornar_mensaje', { mensaje: 'Espere un momento',  estado_del_documento: 'procesando' } ) 
        state.batchList.general = db.batch()
        for await ( let doc of documento.warehouse){
          state.batchList[doc.name] = db.batch()
          await dispatch('obtener_existencias', {doc})
          commit('validar_proceso')
          if( mensaje_de_error.length > 0 ) return dispatch('retornar_mensaje', { mensaje: mensaje_de_error,  estado_del_documento: estado_inicial } )
          await dispatch('generar_movimiento_de_kardex')
          almacenes_procesados += `${doc.name} `
          await state.batchList[doc.name].commit()
          state.tipo_de_operacion = !es_reversion ? 'entrada' : 'salida'
        } 

        state.batchList.general.commit()
        dispatch('retornar_mensaje', { mensaje: `Se ha procesado correctamente el almacén ${almacenes_procesados}`, estado_del_documento: estado_final } )
        /**MOVIMIENTO CONTABLE */
        await dispatch('Movimientos_contables/movimiento_contable', {
          valor: total_gravada, 
          regla: (tipo_de_operacion === 'entrada') 
            ? !es_reversion ? "Ingreso de mercadería a almacén" : "Salida de mercadería del almacén" 
            : !es_reversion ? "Salida de mercadería del almacén" : "Ingreso de mercadería a almacén",
          proveedor_denominacion, 
          condiciones_de_pago, 
          referencia: `${documento_de_operacion} Nº ${numero_de_operacion}`,
          comprobante: `${tipo_de_comprobante||''} ${serie_comprobante||''} ${numero_comprobante||''}`,
          llave: key, 
          fecha: documento.creado_el
        }, { root: true } ) 
        
      } catch( error ){
        console.log(state, estado_inicial)
        dispatch('retornar_mensaje', { mensaje: `Ha ocurrido un error`, estado_del_documento: state.estado_inicial } )
        console.log(error)
      }
    },
        
    obtener_documento: async ({state, dispatch}) => {
      try{
        const obtener_documento = await state.coleccion_seleccionada.doc(state.key).get()
        state.documento = obtener_documento.data()
      } catch (error) {
        dispatch('retornar_mensaje', { mensaje: 'Ha ocurrido un error al obtener los datos del documento', estado_del_documento: state.estado_inicial } )
        console.log(error)
      }
    },

    obtener_existencias: async ({state, dispatch}, {doc}) => {
      try {
        let arreglo_ultima_operacion_en_total = []
        let arreglo_ultima_operacion = []
        let arreglo_existencia_actual_en_almacen = []
        let arreglo_cantidad_que_queda_en_almacen = []
        let cantidad_que_queda_en_almacen = []
        let ultima_operacion = []
        let { documento } = state
        let { items } = documento
        items.map( ({ key }) => arreglo_ultima_operacion_en_total.push( kardexCollection.doc('total').collection(key).orderBy('creado_el', 'desc').limit(1).get() ) )
        items.map( ({ key }) => arreglo_ultima_operacion.push(kardexCollection.doc(doc.slug).collection(key).orderBy('creado_el', 'desc').limit(1).get()) )
        items.map( ({ key }) => arreglo_existencia_actual_en_almacen.push(productsCollection.doc( key ).get()))
        if (state.tipo_de_operacion === 'salida') items.map( ({key}) =>  arreglo_cantidad_que_queda_en_almacen.push( kardexCollection.doc(doc.slug).collection(key).where('entradas_subtotal', '>', 0 ).get() ) )
        
        arreglo_ultima_operacion = await Promise.all(arreglo_ultima_operacion) 
        arreglo_existencia_actual_en_almacen = await Promise.all(arreglo_existencia_actual_en_almacen) 
        arreglo_ultima_operacion_en_total = await Promise.all(arreglo_ultima_operacion_en_total)
        if (state.tipo_de_operacion === 'salida') arreglo_cantidad_que_queda_en_almacen = await Promise.all(arreglo_cantidad_que_queda_en_almacen) 
        
        for ( let i = 0; i < items.length; i++){
          if (state.tipo_de_operacion === 'salida') cantidad_que_queda_en_almacen = ( arreglo_cantidad_que_queda_en_almacen[i].empty) 
            ? []
            : arreglo_cantidad_que_queda_en_almacen[i].docs.map(item => ({...item.data(), key: item.id})).sort((a,b) => a.creado_el.seconds - b.creado_el.seconds, 0 )
        
          ultima_operacion = (arreglo_ultima_operacion[i].empty) 
            ? []
            : arreglo_ultima_operacion[i].docs.map(item => item.data())[0]

          state.existenceToUpdate[items[i].key] = arreglo_existencia_actual_en_almacen[i].data().existence  
  
          state.documento.items[i] = ({...items[i], selectedWarehouse: doc, batchWarehouse: doc.name, cantidad_que_queda_en_almacen, ultima_operacion })

          const ultima_operacion_en_total = ( arreglo_ultima_operacion_en_total[i].empty ) 
            ? { existencias_cantidad: 0 }
            : arreglo_ultima_operacion_en_total[ i ].docs.map(item => item.data())[0]
          state.arreglo_ultima_operacion_en_total[ items[i].key ] = ultima_operacion_en_total.existencias_cantidad
        } 
      } catch (error){
        dispatch('retornar_mensaje', { mensaje: 'Ha ocurrido un error al obtener los datos', estado_del_documento: state.estado_inicial } )
        console.log(error)
      }
    },

    generar_movimiento_de_kardex: async ( {state, dispatch, commit} ) => {
      const {documento, existenceToUpdate, batchList, estado_inicial, es_reversion} = state
      try{
        commit('obtener_costo_del_kardex')
        commit('llenar_operacion_de_kardex' )

        state.documento.items.map( item => {
          const { batchWarehouse, selectedWarehouse, key, movimiento_de_kardex } = item 
          state.batchList[batchWarehouse].set( kardexCollection.doc(selectedWarehouse.slug).collection(key).doc(), movimiento_de_kardex )
          state.existenceToUpdate[key] = { ...state.existenceToUpdate[key], [selectedWarehouse.name.trim()]: movimiento_de_kardex.existencias_cantidad }
          item.costo = movimiento_de_kardex.salidas_costo
        } )

        if ( state.tipo_de_operacion == 'salida' && !es_reversion ) dispatch('actualizar_documento', state.documento.items)
        if ( state.motivo_sin_variacion_en_almacen_total.indexOf(documento.motivo_de_traslado) == -1 ) {
          commit('llenar_operacion_de_kardex', true )
          state.documento.items.map(({batchWarehouse, key, movimiento_de_kardex}) => { 
            state.batchList[batchWarehouse].set( kardexCollection.doc('total').collection(key).doc(), movimiento_de_kardex )
            state.existenceToUpdate[key] = { ...state.existenceToUpdate[key], ['TOTAL']: movimiento_de_kardex.existencias_cantidad }
          })
        } 
  
        Object.keys(existenceToUpdate).map(item => batchList[documento.items[0].batchWarehouse].update(productsCollection.doc(item), { existence: existenceToUpdate[item] }) )

      } catch(error) {
        dispatch('retornar_mensaje', { mensaje: 'Ha ocurrido un error al generar el movimiento', estado_del_documento: state.estado_inicial } )
        console.log(error)
      }
    },
  
    actualizar_documento: ({state}, items)=>{
      let nuevos_items = items.map(item =>( {
        anticipo_documento_numero: item.anticipo_documento_numero || '',
        anticipo_documento_serie: item.anticipo_documento_serie || '',
        anticipo_regularizacion: item.anticipo_regularizacion || '',
        cantidad: item.cantidad,
        codigo: item.codigo,
        codigo_producto_sunat: item.codigo_producto_sunat,
        costo: item.costo, 
        createdAt: item.createdAt,
        descripcion: item.descripcion,
        descuento: item.descuento || 0, 
        igv: item.igv || 0, 
        impuesto_bolsas: item.impuesto_bolsas || 0,
        key: item.key, 
        name: item.name || '', 
        nombre_unidad_de_medida: item.nombre_unidad_de_medida, 
        precio_unitario: item.precio_unitario, 
        presentacion: item.presentacion, 
        subtotal: item.subtotal || 0, 
        tipo_de_igv: item.tipo_de_igv,
        total: item.total || 0, 
        unidad_de_medida: item.unidad_de_medida || 0,
        valor_unitario: item.valor_unitario || 0,
      }))
      console.log(nuevos_items)
      state.batchList.general.update( state.coleccion_seleccionada.doc(state.key), {items: nuevos_items} )
    },
    retornar_mensaje: ({state, dispatch}, objeto) => {
      let {coleccion_seleccionada, key} = state
      coleccion_seleccionada.doc(key).update(objeto)
      dispatch('imprimir', objeto.mensaje ) 
    },

    imprimir: ({commit}, mensaje) => {
      commit('Helpers/launchSnackbar', mensaje, { root: true })
    },
  },

  
  getters:{
    getKardex: ({ record }) =>  record.map(key => ({
        ...key,
        'creado_el': secondsToFullTimestamp(key.creado_el), 
        'almacen_de_origen': key.almacen ? key.almacen[0].name : '',
        'almacen_de_destino': key.almacen &&  key.almacen[1] ? key.almacen[1].name: ''
      })
    )
  }
    
}